import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs';
import { AuthService } from '../../features/auth/services/auth.service';
import { SessionManagerService } from '../services/session-manager.service';
import { AlertService } from '../../shared/services/alert.service';
import { TranslateService } from '@ngx-translate/core';

let isRecovering = false;

function isSubscriptionLimitError(error: HttpErrorResponse): boolean {
  const message = typeof error.error === 'string' ? error.error : error.error?.message || '';
  const msg = message.toLowerCase();
  return ['staff limit', 'restaurant limit', 'delivery', 'insights', 'promo']
    .some(pattern => msg.includes(pattern));
}

export const permissionRecoveryInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const sessionManagerService = inject(SessionManagerService);
  const alertService = inject(AlertService);
  const translate = inject(TranslateService);
  const router = inject(Router);

  if (req.url.includes('/auth/')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403 && !isSubscriptionLimitError(error) && !isRecovering) {
        isRecovering = true;
        authService.updateToken(null).subscribe({
          next: (token) => {
            sessionManagerService.saveToken(token);
            alertService.info(translate.instant('permission.recovery.redirect'));
            router.navigate(['/dashboard']);
            isRecovering = false;
          },
          error: () => {
            sessionManagerService.signOut();
            isRecovering = false;
          }
        });
      }
      throw error;
    })
  );
};
